export default "/gift_banner_2.c8e5f5db-ef03a2.png";